import { getPersonalPropertyItem } from '../graphql/personalPropertyItems';

import { useQuery } from '@tanstack/react-query';
import { QueryPersonalPropertyItemArgs } from '../generated/graphql';
import { useGraphqlClient } from '../graphql';
import { personalPropertyItemKeys } from './queryKeys';

export const usePersonalPropertyItem = ({ householdID, id }: QueryPersonalPropertyItemArgs) => {
  const gqlClient = useGraphqlClient();

  const personalPropertyItemQuery = useQuery({
    enabled: !!householdID && !!id,
    queryKey: personalPropertyItemKeys.personalPropertyItem({ householdID, id }),
    queryFn: () => {
      if (householdID && id) return getPersonalPropertyItem(gqlClient, { householdID, id });
    },
  });

  return { personalPropertyItemQuery, personalPropertyItem: personalPropertyItemQuery.data };
};
